// removed by extract-text-webpack-plugin
module.exports = {"seriesSummary":"SeriesSummary__seriesSummary___3vSKk layout__otrp_padCard___3L-Oy layout__otrp_card___3A8Sf","seriesStats":"SeriesSummary__seriesStats___3v-hB"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/series/SeriesSummary.css
// module id = 1088
// module chunks = 0